export enum RectType {
  COVERPLATE = 0,
  COVERSIDE = 1,
}
